import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `card_widget` component.
 * Keep in sync with CardWidgetProps and CardWidgetTab in src/ui/uiConfig/components/CardWidget/CardWidget.tsx
 */
export const cardWidgetPropDocs: ComponentDocMap = {
  card: {
    description: 'Wraps the content in a card with a shadow. Set to false for a flat layout.',
    type: 'boolean',
    example: 'true',
  },
  use_default: {
    description:
      'Applies the code-defined default template for this component type, including default children and DSIs. See defaultUiConfig.ts.',
    type: 'boolean',
    example: 'true',
  },
  tabs: {
    description:
      'Defines named tabs. Each tab selects which child UiConfig IDs are visible. Use this instead of children_ids when you want content grouped into tabs.',
    type: 'CardWidgetTab[]',
    example:
      '[{ title: "__Chart", children: [{ id: 42, override_alias: {}, override_props: {} }] }, { title: "__Table", children: [43] }]',
  },
  'tabs[].title': {
    description: 'Tab label. Prefix with __ for i18n translation.',
    type: 'string',
    example: '"__Production plan"',
  },
  'tabs[].children': {
    description:
      'One or more child UiConfig IDs shown when this tab is active. Can be a single number, an array of numbers, or an array of objects with override_alias/override_props.',
    type: 'UiConfigId | UiConfigId[] | CardWidgetTabItem[]',
    example: '[{ id: 42, override_alias: { opt_job_type_id: 4 } }]',
  },
  'tabs[].children[].id': {
    description: 'Child UI config ID used when the object form is used.',
    type: 'UiConfigId',
    example: '42',
  },
  'tabs[].children[].override_alias': {
    description: 'Alias overrides applied only for this tab child.',
    type: 'UiConfigAliases',
  },
  'tabs[].children[].override_props': {
    description: 'Prop overrides applied only for this tab child.',
    type: 'UiConfigOverrideProps',
  },
  overrideAlias: {
    description: 'Root-level alias override passed to tab content.',
    type: 'UiConfigAliases',
  },
}
